// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__W7B9x","inputDescription":"styles_inputDescription__TCRE_"};